<application-navigation-ui  
    [userName]="userName$ | async"
    [tenantName]="tenantName$ | async"
    [resellerId]="resellerId$ | async"
    (onProfileClick)="onProfileView()"
    (onTenantSwitchClick)="onTenantSwitching()"
    (onLogoutClick)="onLogout()">
</application-navigation-ui>
